import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { BabylonActions, ReactBabylonLink, SceneFrame, SceneNames, Screenlock, StableArrows } from '.';
import { useAppSelector } from '../store/reducers';
import * as log from '../utils/log';
export const SceneWrapper = ({ sceneName, canNavigate, currentView }) => {
    //Create a Connection to the Babylon React Link so that if a message come
    //from the 3d scene to change scenes we can handle that here. We do this for
    //both the scene and the screenlock for the loader.  That way we can hold
    //the screenlock until the scene is fully cooked.
    const [currentScene, setCurrentScene] = useState(sceneName);
    const [isScreenLocked, setIsScreenLocked] = useState(true);
    const horsesState = useAppSelector((state) => state.stable);
    const jockeysState = useAppSelector((state) => state.jockeys);
    const skinsState = useAppSelector((state) => state.skins);
    const configuratorState = useAppSelector((state) => state.configurator);
    const iframeState = useAppSelector((state) => state.iframe);
    useEffect(() => {
        ReactBabylonLink.SetConnection('currentScene', {
            currentState: currentScene,
            set: (value) => {
                var _a;
                if (value === currentScene) {
                    log.warn('Skip current scene setting', value);
                    return;
                }
                setCurrentScene(value);
                (_a = ReactBabylonLink.StateBus.get('currentScene')) === null || _a === void 0 ? void 0 : _a.onChangeDoneObservable.notifyObservers(value);
                BabylonActions.RefreshScene();
            }
        });
        return () => {
            ReactBabylonLink.RemoveConnection('currentScene');
        };
    }, [currentScene]);
    useEffect(() => {
        ReactBabylonLink.SetConnection('isScreenLocked', {
            currentState: isScreenLocked,
            set: (value) => {
                var _a;
                setIsScreenLocked(value);
                (_a = ReactBabylonLink.StateBus.get('isScreenLocked')) === null || _a === void 0 ? void 0 : _a.onChangeDoneObservable.notifyObservers(value);
            }
        });
        return () => {
            ReactBabylonLink.RemoveConnection('isScreenLocked');
        };
    }, [isScreenLocked]);
    useEffect(() => {
        ReactBabylonLink.SetConnection('currentHorsesState', {
            currentState: horsesState,
            set: () => { }
        });
        return () => {
            ReactBabylonLink.RemoveConnection('currentHorsesState');
        };
    }, [horsesState]);
    useEffect(() => {
        ReactBabylonLink.SetConnection('currentJockeysState', {
            currentState: jockeysState,
            set: () => { }
        });
        return () => {
            ReactBabylonLink.RemoveConnection('currentJockeysState');
        };
    }, [jockeysState]);
    useEffect(() => {
        ReactBabylonLink.SetConnection('currentSkinsState', {
            currentState: skinsState,
            set: () => { }
        });
        return () => {
            ReactBabylonLink.RemoveConnection('currentSkinsState');
        };
    }, [skinsState]);
    useEffect(() => {
        ReactBabylonLink.SetConnection('currentConfiguratorState', {
            currentState: configuratorState,
            set: () => { }
        });
        return () => {
            ReactBabylonLink.RemoveConnection('currentConfiguratorState');
        };
    }, [configuratorState]);
    const frame = useMemo(() => {
        log.debug('useMemo SceneWrapper', {
            style: iframeState.style,
            isScreenLocked,
            currentScene,
            canNavigate,
            currentView
        });
        return (_jsxs("div", Object.assign({ style: iframeState.style }, { children: [_jsx(Screenlock, { isLocked: isScreenLocked }), _jsx(SceneFrame, Object.assign({ currentScene: SceneNames[currentScene] }, { children: _jsx(StableArrows, { isLocked: !canNavigate }) }))] })));
    }, [iframeState.style, isScreenLocked, currentScene, canNavigate, currentView]);
    return frame;
};
